import { createContext } from 'react';
import type { GiftCardVariant } from '@storefront/lib-global/codegen/types';
import type { OccasionAndDenominationContextType } from './OccasionAndDenominationContextType';

export const OccasionAndDenominationContext = createContext<OccasionAndDenominationContextType>({
  selectedOccasionVariant: {} as GiftCardVariant,
  selectedPriceDenomination: '',
  uniqueOccasions: [],
  uniquePriceDenominations: [],
  isSingleOccasion: false,
  handleChangeOccasion: () => {},
  handleChangePriceDenomination: () => {},
  selectedGiftCardSku: '',
  priceDenominationError: false,
  setPriceDenominationError: () => {},
});
